module.exports = __webpack_public_path__ + "img/technology-9.8867a2cf.png";